let position = 0;
let count = 1;
let time = 400;
let stTime = 80;
let xTouch, yTouch, xDiff, yDiff, mvTime;
let touchPrev = true;
let touchNext = true;

const getTime = () => {
    return new Date().getTime();
}

let bgTime = getTime();

const getDomElements = () => {
    const elem = document.querySelector('.flex-control-nav.flex-control-thumbs > li');
    const elemStyle = window.getComputedStyle(elem);
    const width = elem.offsetWidth +  parseInt(elemStyle.marginLeft) + parseInt(elemStyle.marginRight);
    const list = document.querySelector('.flex-control-thumbs');
    const listElems = document.querySelectorAll('.flex-control-thumbs > li');
    return [width, list, listElems];
}

const currentPosition = () => {
    const [width, list] = getDomElements();
    setTimeout(() => {
    const [curIndex] = getCurrentImg();
    const position = -curIndex * width;
    list.style.marginLeft = position + 'px';
    return position;
}, 300);
}

const getCurrentImg = () => {
    const current = document.querySelector('.woocommerce-product-gallery__image.flex-active-slide');
    const list = document.querySelectorAll('.woocommerce-product-gallery__image');
    let currentIndex;
    list.forEach((item, index) => item === current ? currentIndex = index : '');
    const data = [currentIndex, list.length];
    return data;
}

const reset = () => {
    const [width, list] = getDomElements();
    btn = document.querySelector('.flex-next');
    setTimeout(() => { 
        const [index, all] = getCurrentImg();
        for(index; index <= all; index++) {
            incrementImg(btn);
        }
    },200);
    position = 0;
    list.style.marginLeft = position + 'px';
    return position;
}

const clone = (btn) => {
    const parent = document.querySelector('.flex-control-nav');
    if(btn.classList.contains('flex-next')) {
        let img = document.querySelector('.flex-control-nav > li');
        parent.append(img);
        img = document.querySelector('.flex-control-nav > li');
    }
    if(btn.classList.contains('flex-prev')) {
        img = parent.lastElementChild;
        parent.prepend(img);
        img = document.querySelector('.flex-control-nav > li');
    }
}

const disabledBtn = (btn) => {
    btn.disabled = true;
    setTimeout(() => { btn.disabled = false }, time);
}

const decrementImg = (btn) => {
    disabledBtn(btn);
    const [width, list] = getDomElements();
        position += width * count;
        position = Math.min(position, 0);
        list.style.marginLeft = position + 'px';
        clone(btn);
        return position;
}

const incrementImg = (btn) => {
    disabledBtn(btn);
    const [width, list, listElems] = getDomElements();
    position -= width * count;
    position = Math.max(position, 0);
    list.style.marginLeft = position + 'px';
    clone(btn);
    return position;
}

const updateCurrentPosition = (currentPositionIndex) => {
    position = currentPositionIndex;
    return position;
}

const initTrumbsSlider = (renderThumbs, renderSelect) => {
    if(renderThumbs) {
        if(renderSelect) {
            const selectColor = document.querySelectorAll('.variations select');
            selectColor.forEach((item) => {
                item.addEventListener('change', currentPosition);
            });
        }

        const navNext     = document.querySelectorAll('.flex-next');
        const navPrev     = document.querySelectorAll('.flex-prev');
        const resetBtn    = document.querySelector('.reset_variations');

        navPrev.forEach((item) => {
            item.addEventListener('click', () => decrementImg(item));
            item.addEventListener('touchstart', (e) => {
                xTouch = parseInt(e.touches[0].clientX);
                yTouch = parseInt(e.touches[0].clientY);
                stTime = getTime();
                decrementImg(item);
            }, false);
        });

        navNext.forEach((item) => {
            item.addEventListener('click', () => incrementImg(item));
            item.addEventListener('touchstart', (e) => {
                xTouch = parseInt(e.touches[0].clientX);
                yTouch = parseInt(e.touches[0].clientY);
                stTime = getTime();
                incrementImg(item);
            }, false);
        });

        resetBtn.addEventListener('click', reset);
    }
}

setTimeout(() => {
    const renderThumbs = document.querySelector('.flex-control-thumbs');
    const renderSelect = document.querySelectorAll('.variations select').length > 0;
    if(renderThumbs) {
        initTrumbsSlider(renderThumbs, renderSelect);
    }
}, 300);